import { render, staticRenderFns } from "./RecordDownload.vue?vue&type=template&id=42ed7109"
import script from "./RecordDownload.vue?vue&type=script&lang=js"
export * from "./RecordDownload.vue?vue&type=script&lang=js"
import style0 from "./RecordDownload.vue?vue&type=style&index=0&id=42ed7109&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
